import { createTheme } from '@material-ui/core/styles';

export const defaultTableTheme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    borderRadius: "4px", // Preserves the DataGrid's border radius for consistency
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    color: "#212121",
                    fontWeight: 'bold',
                },
            }
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    padding: "4px", // Keeps the reduced padding for header cells
                    fontSize: "0.925rem", // Increases font size for headers for better readability
                    position: 'relative',
                    '&:hover::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: '1px',
                        backgroundColor: '#e0e0e0', // Subtle border color for hover effect
                    },
                    '&:hover::after': {
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        bottom: 0,
                        width: '1px',
                        backgroundColor: '#e0e0e0', // Subtle border color for hover effect
                    },
                },
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: "4px", // Maintains reduced padding for body cells
                    fontSize: "0.875rem", // Slightly larger font size for body text for improved readability
                    borderBottom: "none", // Continues to have no bottom border on cells
                },
                head: {
                    color: "#212121",
                    fontWeight: 'bold',
                }
            }
        },
        MUIDataTableBodyRow: {
            styleOverrides: {
                root: {
                    borderBottom: "1px solid #e0e0e0", // Keeps the bottom border on rows
                    '&:hover': {
                        backgroundColor: "rgba(224, 224, 224, 1)" // Maintains the hover effect for rows
                    }
                }
            }
        },
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    alignItems: 'flex-start',
                },
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                body2: {
                    fontWeight: 'bold',
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                icon: {
                    color: '#212121',
                    fontWeight: 'bold',
                }
            }
        },
        MUIDataTableToolbar: {
            styleOverrides: {
                root: {
                    minHeight: '10px', 
                    padding: '4px 8px',
                },
                title: {
                    fontSize: '1rem', 
                },
            }
        },
    }
});






export const darkModeTableTheme = createTheme({
    palette: {type: 'dark'},
    overrides: {
        MUIDataTable:{
            paper: {
                boxShadow: "none"
            }
        },
        MuiTable:{
            root: {
                border: [[1, 'solid', '#626262']],
            },
        },
        MUIDataTableToolbar:{
            root:{
                backgroundColor:"#ff851b"
            }
        },
        MuiButton:{
            //table header text
            root:{
                color:"#FFFFFF"
            },
            text:{
                fontWeight:'900'
            }
        },
        MUIDataTableHeadCell: {

            root: {
                color:"#eeeeee",
                borderColor: '#626262',
                '&:not(:last-child)': {
                borderRight: [[1, 'solid', '#626262']],
                },
            },
            fixedHeader: {
                //color for header background
                backgroundColor: '#252323 !important',
                '&:not(:last-child)': {
                borderRight: [[1, 'solid', '#626262']],
                },
            },
            sortActive:{
                color:"#FFFFFF"
            }
        },
        MUIDataTableSelectCell:{

            root: {
                borderColor: '#626262',
                '&:not(:last-child)': {
                borderRight: [[1, 'solid', '#626262']],
                },
            },
            fixedHeader: {
                //color for header background
                backgroundColor: '#252323 !important',
                '&:not(:last-child)': {
                borderRight: [[1, 'solid', '#626262']],
                },
            },
        },
        MuiTableCell: {
            root: {
                borderColor: '#626262',
                '&:not(:last-child)': {
                borderRight: [[1, 'solid', '#626262']],
                },
            }
        },
        MUIDataTableBodyRow: {
            root: {
                '&:nth-of-type(even)': { 
                    backgroundColor: "#3a3a3a"
                },
                '&:nth-of-type(odd)': { 
                    backgroundColor: "#2b2b2b"
                }
            }
        },
        MuiTableSortLabel: {
            
            root: {
                alignItems: 'flex-start',
            },
        },
        MuiTableFooter: {
            root: {
                backgroundColor: '#4C4C4C  !important',
            },
        },
        MuiTablePagination:{
            root:{
                color:'#FFFFFF'
            },
            actions:{
                fontWeight:"900"
            }
        },
        MuiInputBase:{
            root:{
                fontWeight:'900'
            }
        },
        MuiTypography:{
            body2:{
                fontWeight:'900'
            }
        },
        MuiSelect:{
            icon:{
                color:'#FFFFFF',
                fontWeight:'900'
            }
        },

        MuiSvgIcon:{
            root:{
                color:'#FFFFFF'
            }
        }
        

    }
});



export const light = {
    table: {
        style: {
            border:'solid',
            borderWidth:'1px',
            borderColor:'#ffffff'
        },
    },
    rows: {
        style:{
            '&:nth-of-type(even)': { 
                backgroundColor: "#ECEFF1"
            }
    }
    },

    headRow:{
        style:{
            backgroundColor: "#BDBDBD",
        }
    },
    headCells: {
        style: {
            fontWeight:'900',
            color:'#212121',
            '&:not(:last-child)': {
                borderRight:'solid',
                borderRightWidth:'1px',
                borderRightColor:'#FFFFFF'
                },
            
        },
    },
    cells:{
        style:{
            '&:not(:last-child)': {
                borderRight:'solid',
                borderRightWidth:'1px',
                borderRightColor:'#ffffff'
                },
        }
    },
    pagination:{
        style:{
            backgroundColor: '#4C4C4C',
            color:'#FFFFFF',
            fontWeight:'900'
        },
        pageButtonsStyle:{
            color:'#FFFFFF',
            fontWeight:'900',
            fill:'#FFFFFF',
            '&:disabled': {
                fontWeight:'900',
                fill:'#999999'
    
            },
        },

    }
};